module.exports = __webpack_public_path__ + "static/socage-da22-112ee496274e61c07765d6f452bcc690.jpg";